import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default, { forwardRef } from 'react';
import clsx from 'clsx';
import { Input } from '../Input/Input.es.js';

const textInput = "_text-input_o0wi4_1";
const styles = {
	textInput: textInput
};

const TextInput = forwardRef((_a, ref) => {
  var { defaultValue, isMultiline = false, type = "text", isFullWidth = false, size = "medium", borderRadius, className } = _a, otherProps = __rest(_a, ["defaultValue", "isMultiline", "type", "isFullWidth", "size", "borderRadius", "className"]);
  const props = Object.assign({
    isMultiline,
    type,
    isFullWidth,
    size,
    borderRadius
  }, otherProps);
  const Tag = props.isMultiline ? "textarea" : "input";
  return React__default.createElement(Input, Object.assign({}, props, { renderIconAfter: props.isMultiline ? void 0 : props.renderIconAfter, renderIconBefore: props.isMultiline ? void 0 : props.renderIconBefore }), (inputProps) => React__default.createElement(Tag, Object.assign({}, inputProps, { autoCapitalize: props.autoCapitalize, autoCorrect: props.autoCorrect, className: clsx(styles.textInput, className, inputProps.className), defaultValue, inputMode: props.inputMode, ref, rows: props.isMultiline ? props.rows : void 0, spellCheck: props.spellCheck, type: !props.isMultiline ? props.type : void 0, value: inputProps.value, onChange: inputProps.onChange, "data-zds": true, "data-multiline": isMultiline, "data-fullwidth": isFullWidth, "data-size": size, "data-resize": props.resize })));
});

export { TextInput };
//# sourceMappingURL=TextInput.es.js.map
